import { configureStore } from "@reduxjs/toolkit";

// API
import { oauthApi } from "@/features/OAuth/OAuth.api";
import { workspaceApi } from "@/features/Workspace/Workspace.api";
import { contentTableApi } from "@/features/ContentTable/ContentTable.api";
import { uploadApi } from "@/features/Upload/Upload.api";
import { memberApi } from "@/features/Member/Member.api";
import { contentApi } from "@/features/Content/Content.api";
import { feedbackApi } from "@/features/Feedback/Feedback.api";
import { notificationApi } from "@/features/Notification/Notification.api";
import { settingApi } from "@/features/Setting/Setting.api";

// Reducers
import workspaceReducer from "@/features/Workspace/Workspace.slice";
import memberReducer from "@/features/Member/Member.slice";
import oauthReducer from "@/features/OAuth/OAuth.slice";
import contentReducer from "@/features/Content/Content.slice";
import contentTableReducer from "@/features/ContentTable/ContentTable.slice";

export const makeStore = () => {
  return configureStore({
    reducer: {
      // API Reducers
      [workspaceApi.reducerPath]: workspaceApi.reducer,
      [contentTableApi.reducerPath]: contentTableApi.reducer,
      [uploadApi.reducerPath]: uploadApi.reducer,
      [memberApi.reducerPath]: memberApi.reducer,
      [oauthApi.reducerPath]: oauthApi.reducer,
      [contentApi.reducerPath]: contentApi.reducer,
      [feedbackApi.reducerPath]: feedbackApi.reducer,
      [notificationApi.reducerPath]: notificationApi.reducer,
      [settingApi.reducerPath]: settingApi.reducer,

      // Slice Reducers
      oauth: oauthReducer,
      workspace: workspaceReducer,
      contentTable: contentTableReducer,
      member: memberReducer,
      content: contentReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        workspaceApi.middleware,
        contentTableApi.middleware,
        uploadApi.middleware,
        memberApi.middleware,
        oauthApi.middleware,
        contentApi.middleware,
        feedbackApi.middleware,
        notificationApi.middleware,
        settingApi.middleware,
      ),
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
